import React from 'react';
import '../assets/app.css'
import ProductApi from '../api/product';
import DiscountApi from '../api/discount'
import Header from './Header'
import Footer from './Footer'
import OrderApi from '../api/order';
import WithRouter from '../hoc/WithRouter';
import AppCache from '../modules/AppCache';
import SimpleReactValidator from 'simple-react-validator';
import constants from '../constants/constants'
// import { BrowserRouter as Router, Route, useHistory } from 'react-router-dom';
import LicenseApi from '../api/license';
//import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
import LoadingOverlay from 'react-loading-overlay-ts';
import * as _ from 'lodash';
import countries from './countries';
// import ReactGA from 'react-ga';
import LazyLoad from './LazyLoad';

// import { 
//     isValid, 
//     isExpirationDateValid, 
//     isSecurityCodeValid, 
//     getCreditCardNameByNumber 
//   } from 'creditcard.js';
var valid = require("card-validator");
//toast.configure()
//var dropin = require('braintree-web-drop-in');
var braintree = require('braintree-web');
var paypal = require('paypal-checkout');
//var qs = require('qs')
const emailValidator = require('email-validator')

/** Match PayPal JS `env` to the Braintree client token (sandbox vs production). NODE_ENV alone does not. */
function getPayPalEnvFromBraintreeAuthorization(authorizationKey) {
    if (!authorizationKey || typeof authorizationKey !== 'string') {
        return process.env.NODE_ENV === 'production' ? 'production' : 'sandbox';
    }
    const trimmed = authorizationKey.trim();
    if (trimmed.startsWith('sandbox_')) return 'sandbox';
    if (trimmed.startsWith('production_')) return 'production';
    const parts = trimmed.split('.');
    if (parts.length === 3) {
        try {
            const base64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
            const pad = base64.length % 4;
            const padded = pad ? base64 + '='.repeat(4 - pad) : base64;
            const payload = JSON.parse(atob(padded));
            const env = payload.braintree_api && payload.braintree_api.environment;
            if (env === 'production') return 'production';
            if (env === 'sandbox') return 'sandbox';
        } catch (e) {
            /* fall through */
        }
    }
    return process.env.NODE_ENV === 'production' ? 'production' : 'sandbox';
}

const ONE_YEAR_DISCOUNT_PREFIX = "DF"
const TWO_YEAR_DISCOUNT_PREFIX = "DS"
//const TWO_YEAR_FOR_ONE_YEAR_DISCOUNT_PREFIX = "D1P1"
const MW3_MONTLY_DISCOUNT_PREFIX = 'DR'
class Order extends React.Component {
    instance

    isMobile() {	//sniff a mobile browser
		if (navigator.userAgent.match(/Android/i) ||
			navigator.userAgent.match(/webOS/i) ||
			navigator.userAgent.match(/iPad/i) ||
			navigator.userAgent.match(/iPhone/i) ||
			navigator.userAgent.match(/iPod/i)
		) {
			return true;
		}
		else return false;
	};

    constructor(props) {
        super(props);
        this.form = React.createRef();
        this.validate = this.validate.bind(this);
        this.validator = new SimpleReactValidator()
        const query = new URLSearchParams(window.location.search);
        var result = null
        var flag = query.get('flag');
        var paypalActions = '';
        if (flag === 'true') {
            result = AppCache.getRedeemData()
        }

        this.state = {
            licenses: [],
            clientToken: null,
            fields: {},
            isValid: true,
            selectedLicenseType: 0,
            selectedLicense: {},
            discountEnable: false,
            discountAmount: 0.00,
            discountCouponNumber: '',
            flag: flag,  //Change this at a time of production
            applyDiscount: false,
            discountCode: '',
            license: [],
            loading: false,
            visible: false,
            showSidebar: false,
            showText: true,
            errorMessage: '',
            errorMessageProcess: false,
            formValidationState: false,
            postalCodeError: false,
        };
        this.orderInFlight = false;
        this._submitHandler = null;
        this._formElement = null;
    }

    async init() {
        const _this = this;
        let key;
        try {
            key = await OrderApi.findSecretConstants()
            
            // Validate that we received a valid response with authorizationKey
            if (!key || !key.authorizationKey) {
                console.error('Failed to retrieve Braintree authorization key. Response:', key);
                this.setState({ loading: false });
                alert('Payment system initialization failed. Please refresh the page or contact support.');
                return; 
            }
        } catch (error) {
            console.error('Error fetching secret constants:', error);
            this.setState({ loading: false });
            alert('Payment system initialization failed. Please refresh the page or contact support.');
            return;
        }

        const paypalButtonEnv = getPayPalEnvFromBraintreeAuthorization(key.authorizationKey);

        var form = document.querySelector('#my-sample-form');
        var submit = document.querySelector('input[type="submit"]');

        // console.log(paypal);
        this.setState({ loading: true })
        braintree.client.create({
            authorization: key.authorizationKey
        }, function (clientErr, clientInstance) {
            if (clientErr) {
                console.error(clientErr);
                return;
            }

            // This example shows Hosted Fields, but you can also use this
            // client instance to create additional components here, such as
            // PayPal or Data Collector.

            //console.log(braintree.paypal)

            braintree.hostedFields.create({

                client: clientInstance,
                styles: {
                    'input': {
                        'required': 'required',
                        'padding': '0.5rem 0.5rem',
                        'font-size': '18px',
                        'font-family': 'system-ui',
                        'font-weight': '300'
                    },
                    '.number': {
                        'font-family': 'system-ui',
                        'font-weight': '300'
                      },
                    'input:placeholder': {
                        'font-size': '18px',
                        'required': 'required',
                        'padding': '0.5rem 0.5rem',
                        'font-family': 'system-ui',
                        'font-weight': '300'
                    },
                   
                    'input.invalid': {
                        'color': 'red'
                    },
                    //   'input.valid': {
                    //     'color': 'green'
                    //   },
                    'select': {
                        'font-size': '18px',
                        'padding': '0.5rem 1rem',
                        '-webkit-appearance': 'none',
                        'font-family': 'system-ui',
                        'font-weight': '300',
                        'color': 'black',
                    },
                    'option': {'font-weight': '300', 'color': 'black'}
                },
                fields: {
                    number: {
                        container: '#card-number',
                        placeholder: 'Enter Credit Card Number'
                    },
                    expirationMonth: {
                        container: '#expiration-month',
                        select: {
                            options: [
                                '01',
                                '02',
                                '03',
                                '04',
                                '05',
                                '06',
                                '07',
                                '08',
                                '09',
                                '10',
                                '11',
                                '12'
                            ]
                        }
                    },
                    expirationYear: {
                        container: '#expiration-year',
                        select: true
                    },
                    //   expirationDate: {
                    //     container: '#expiration-date',
                    //     placeholder: 'MM/YYYY'
                    //   },
                    cvv: {
                        container: '#cvv',
                        placeholder: 'CVV'
                    }
                }
            }, function (hostedFieldsErr, hostedFieldsInstance) {
                if (hostedFieldsErr) {
                    return;
                }

                submit.removeAttribute('disabled');
                _this._submitHandler = function (event) {
                    event.preventDefault();

                    if (_this.orderInFlight) {
                        return;
                    }
                    _this.orderInFlight = true;
                    _this.setState({ loading: true });

                    hostedFieldsInstance.tokenize(function (tokenizeErr, payload) {
                        if (tokenizeErr) {
                            _this.handleTokenErrorCard(tokenizeErr)
                            _this.orderInFlight = false;
                            _this.setState({ loading: false })
                            return;
                        }
                        _this.cardValide(payload)
                        _this.handleTokenErrorCard(tokenizeErr)
                        _this.processOrder(hostedFieldsInstance)
                    });
                };
                _this._formElement = form;
                form.addEventListener('submit', _this._submitHandler, false);
            });
        });

        // Create a client for PayPal checkout.
        braintree.client.create({
            authorization: key.authorizationKey
        }, function (clientErr, clientInstance) {

            if (clientErr) {
                console.error('Error creating client:', clientErr);
                return;
            }


            braintree.paypalCheckout.create({
                client: clientInstance
            }, function (paypalCheckoutErr, paypalCheckoutInstance) {
                paypalCheckoutInstance.loadPayPalSDK({
                    vault: true
                }, function () {
                    _this.setState({ loading: false, showSidebar: true, showText: false });
                    var actionStatus;
                    paypal.Button.render({
                        env : paypalButtonEnv,
                        commit: true,
                        style: {
                            shape: 'rect',
                            label: 'paypal',
                            height: 40.5,
                            tagline: 'false',
                        },

                        payment: function () {
                            return paypalCheckoutInstance.createPayment({
                                flow: 'vault', // Required
                            });
                        },

                        validate(actions) {
                            if(_this.isMobile()) {
                                actions.disable();
                                actionStatus = actions;
                                document.querySelectorAll(".validate7").forEach(i => {
                                    if (document.querySelectorAll("#paypal-button"))
                                        i.addEventListener("change", () => {
                                            var valid = true;
                                            if (valid) { actions.enable();} else { actions.disable();}
                                        });
                                });
                                document.querySelectorAll(".validate8").forEach(i => {
                                    if (document.querySelectorAll("#paypal-button"))
                                        i.addEventListener("change", () => {
                                            var valid = true;
                                            if (valid) { actions.enable();} else { actions.disable()}
                                        });
                                });
                            }
                            actions.disable();
                            actionStatus = actions;
                            document.querySelectorAll("#phone").forEach(i => {
                                if (document.querySelectorAll("#paypal-button"))
                                    i.addEventListener("change", () => {
                                        if (_this.validate()) {
                                            actions.enable();
                                        } else {
                                            actions.disable();
                                        }
                                    });
                            });

                        },
                        onClick: function (e) {

                            // if( !_this.validate()){
                            //     _this.validate();
                            // }

                            let val = _this.validate(); //returns status from your Custom Validation Checkpoint
                            if (!val) {
                                actionStatus.disable();
                            } else {
                                actionStatus.enable();
                            }
                        },

                        onApprove: function (data, actions) {
                            if (_this.orderInFlight) {
                                return;
                            }
                            _this.orderInFlight = true;
                            _this.setState({ loading: true })
                            paypalCheckoutInstance.tokenizePayment(data, function (err, payload) {
                                let nonce = payload.nonce
                                _this.processOrderPaypal(nonce)
                            });
                        },

                        onCancel: function (data) {
                            //console.log('PayPal payment canceled', JSON.stringify(data, 0, 2));
                            console.log('PayPal payment canceled');
                        },

                        onError: function (err) {
                            console.error('PayPal error', err);
                        }
                    }, '#paypal-button').then(function () {

                        // The PayPal button will be rendered in an html element with the ID
                        // `paypal-button`. This function will be called when the PayPal button
                        // is set up and ready to be used
                    });

                });

            });

        });
    }

    cardValide(payload) {

        var numberValidation = valid.number(payload.details.bin);
        if (!numberValidation.isPotentiallyValid) {
            const tokenErrorCard = ''
            this.setState({ cardError: tokenErrorCard, errorMessageProcess: false })
        }

        var expirationMonth = valid.expirationMonth(payload.details.expirationMonth)
        if (!expirationMonth.isPotentiallyValid) {
            const tokenErrorExptMonthYear = ''
            this.setState({ monthYearError: tokenErrorExptMonthYear, errorMessageProcess: false })
        }

        var expirationYear = valid.expirationYear(payload.details.expirationYear)
        if (!expirationYear.isPotentiallyValid) {
            const tokenErrorExptMonthYear = ''
            this.setState({ monthYearError: tokenErrorExptMonthYear, errorMessageProcess: false })
        }

        var cvv = valid.cvv(payload.details.cvv)
        if (!cvv.isPotentiallyValid) {
            const tokenErrorCvv = ''
            this.setState({ cvvError: tokenErrorCvv, errorMessageProcess: false })
        }
    }

    handleTokenErrorCard(tokenizeErr) {
        if (tokenizeErr === null || tokenizeErr === "") {
            const tokenErrorCard = ''
            const tokenErrorCvv = ''
            const tokenErrorExptMonthYear = ''
            this.setState({ cardError: tokenErrorCard, cvvError: tokenErrorCvv, monthYearError: tokenErrorExptMonthYear, errorMessageProcess: false, postalCodeError: false })
        }
        if (tokenizeErr === null || tokenizeErr === "") {
            const tokenErrorCard = ''
            this.setState({ cardError: tokenErrorCard, errorMessageProcess: false, postalCodeError: false })
        } else if (tokenizeErr.details.invalidFieldKeys[0] === 'number') {
            const tokenErrorCard = tokenizeErr.details.invalidFields['number']
            this.setState({ cardError: tokenErrorCard, errorMessageProcess: false, postalCodeError: false })
        } else {
            const tokenErrorCard = ''
            this.setState({ cardError: tokenErrorCard, errorMessageProcess: false, postalCodeError: false })
        }

        if (tokenizeErr === null || tokenizeErr === "") {
            const tokenErrorCvv = ''
            this.setState({ cvvError: tokenErrorCvv })
        } else if (tokenizeErr.details.invalidFieldKeys[0] === 'cvv') {
            const tokenErrorCvv = tokenizeErr.details.invalidFields['cvv']
            this.setState({ cvvError: tokenErrorCvv, errorMessageProcess: false, postalCodeError: false })
        } else {
            const tokenErrorCvv = ''
            this.setState({ cvvError: tokenErrorCvv, errorMessageProcess: false, postalCodeError: false })
        }

        if (tokenizeErr === null || tokenizeErr === "") {
            const tokenErrorExptMonthYear = ''
            this.setState({ monthYearError: tokenErrorExptMonthYear })
        } else if (tokenizeErr.details.invalidFieldKeys[0] === 'expirationMonth') {
            const tokenErrorExptMonthYear = tokenizeErr.details.invalidFields['expirationMonth']
            this.setState({ monthYearError: tokenErrorExptMonthYear, errorMessageProcess: false, postalCodeError: false })
        } else {
            const tokenErrorExptMonthYear = ''
            this.setState({ monthYearError: tokenErrorExptMonthYear, errorMessageProcess: false, postalCodeError: false })
        }
    }

    validateRequiredField(field) {
        let formIsValid = true;
        let fields = this.state.fields;
        if (!fields[field]) {
            formIsValid = false;
        }
        return formIsValid
    }

    // validate() {

    //         if(this.form.current.reportValidity() === false)
    //         return false;
    //         else {
    //             let fields = this.state.fields
    //             const format = /^[A-Za-z0-9 ]+$/
    //             const validPostalCode = format.test(document.getElementById("zip").value)        
    //             if (!validPostalCode) {
    //                 alert("Contains Special Characters.");
    //                 fields['zip'] = ""
    //                 return fields;
    //             } 
    //         return true;
    //     }
    // }

    validate() {
        let fields = this.state.fields
        if (this.form.current.reportValidity() === false)
            return false;
        else
            if (_.isEmpty(fields['firstName']) || _.isEmpty(fields['lastName']) || _.isEmpty(fields['addressOne']) || _.isEmpty(fields['city']) || _.isEmpty(fields['zip']) || _.isEmpty(fields['state']) || _.isEmpty(fields['country']) || _.isEmpty(fields['email']) || _.isEmpty(fields['phone'])) {
                this.setState({ loading: false, formValidationState: true })
                return;
            } else {
                this.setState({ formValidationState: false })
            }
        return true;
    }

    validateForm() {
        let formIsValid = true;
        let fields = this.state.fields
        if (!fields['firstName']) {
            formIsValid = false;
            this.firstName.className += ' form_text_error'
        }
        if (!fields['lastName']) {
            formIsValid = false;
            this.lastName.className += ' form_text_error'
        }
        if (!fields['addressOne']) {
            formIsValid = false;
            this.addressOne.className += ' form_text_error'
        }
        if (!fields['city']) {
            formIsValid = false;
            this.city.className += ' form_text_error'
        }
        if (!fields['state']) {
            formIsValid = false;
            this.stateVal.className += ' form_text_error'
        }
        if (!fields['zip']) {
            formIsValid = false;
            this.zip.className += ' form_text_error'
        }
        if (!fields['country']) {
            formIsValid = false;
            this.country.className += ' form_text_error'
        }
        if (!fields['email']) {
            formIsValid = false;
            this.email.className += ' form_text_error'
        }
        if (typeof fields["email"] !== "undefined") {
            //regular expression for email validation
            // var pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
            //var pattern = new RegExp("^[\\w!#$%&'*+/=?`{|}~^-]+(?:\\.[\\w!#$%&'*+/=?`{|}~^-]+)*@(?:[a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,6}$");
            //var pattern = new RegExp(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i);

            //if (!pattern.test(fields["email"])) {
            if (!emailValidator.validate(fields["email"])) {
                formIsValid = false;
                this.email.className += ' form_text_error'
            }
        }
        if (!fields['phone']) {
            formIsValid = false;
            this.phone.className += ' form_text_error'
        }

        return formIsValid
    }
    //This Method is written for editing discountCode
    handlechangeDiscount(e) {
        this.setState({
            discountCouponNumber: e.target.value,
        });
    }

    handleChange(e) {
        let fields = this.state.fields;
        // console.log(e)
        fields[e.target.name] = e.target.value;
        // console.log('fields', fields)
        this.setState({
            fields
        });
    }

    submitFormtoApplyDiscount(e) {
        var discountCouponNumber = this.state.discountCouponNumber
        this.discountCalculation(discountCouponNumber, this.state.license)
    }

    onLicenseSelect(license) {
        // console.log('license: ', license);
        this.setState({ selectedLicense: license, discountAmount: license.discountAmount })
    }


    processOrderPaypal = async (nonce) => {
        const { fields, selectedLicense, discountCouponNumber, discountEnable } = this.state
        // toast.error('connection ETIMEDOUT 10.8.0.30:8000. Please try after some time',{position : toast.POSITION.BOTTOM_CENTER})

        let productCode = selectedLicense.productCode
        let product = await ProductApi.findProductByCode(productCode)
        let productConf = this.createProductConfiguration(product, selectedLicense)
        var result = AppCache.getRedeemData()
        if (this.validate()) {

            fields['discounts'] = []
            fields['orderItems'] = [{
                qty: 1,
                productConf: productConf
            }]
            let orderForm = {
                discountEnable: discountEnable,
                upgradeProcessType: result.upgradeProcessType,
                discountCouponNumber: discountCouponNumber,
                nonce: nonce,
                license: selectedLicense,
                order: fields,
            }
            //this.setState({ loading: true })
            this.continueOrderProcessing(orderForm)
        } else {
            this.orderInFlight = false;
            this.setState({ loading: false })
        }
    }

    processOrder = async (hostedFieldsInstance) => {
        const { fields, selectedLicense, discountCouponNumber, discountEnable } = this.state
        // toast.error('connection ETIMEDOUT 10.8.0.30:8000. Please try after some time',{position : toast.POSITION.BOTTOM_CENTER})

        let productCode = selectedLicense.productCode
        let product = await ProductApi.findProductByCode(productCode)
        let productConf = this.createProductConfiguration(product, selectedLicense)
        var result = AppCache.getRedeemData()
        if (this.validate()) {
            //instance.tokenize((tokenizeErr, payload) => {
            hostedFieldsInstance.tokenize((tokenizeErr, payload) => {
                if (tokenizeErr) {
                    this.handleTokenErrorCard(tokenizeErr)
                    this.orderInFlight = false;
                    this.setState({ loading: false })
                    return;
                }
                fields['discounts'] = []
                fields['orderItems'] = [{
                    qty: 1,
                    productConf: productConf
                }]
                let orderForm = {
                    discountEnable: discountEnable,
                    upgradeProcessType: result.upgradeProcessType,
                    discountCouponNumber: discountCouponNumber,
                    nonce: payload.nonce,
                    license: selectedLicense,
                    order: fields,
                }
                //this.setState({ loading: true })
                this.continueOrderProcessing(orderForm)
            })
        } else {
            this.orderInFlight = false;
            this.setState({ loading: false })
        }
    }

    async continueOrderProcessing(orderForm) {
        const { history } = this.props;
        try {
        const key = await OrderApi.findSecretConstants()
        orderForm.encryptedData = key.encryptedData
        orderForm.iv = key.iv
        let result = await OrderApi.processOrder(orderForm)
        switch (result.error) {
            case 'Postal code can only contain letters, numbers, spaces, and hyphens.':
            return this.setState({ loading: false, postalCodeError: true, errorMessageProcess: false })
            case 'Gateway Rejected: cvv':
            return this.setState({ loading: false, postalCodeError: false, errorMessageProcess: 'Invalid CVV number, please correct.' })
            case 'Insufficient Funds':
            return this.setState({ loading: false, postalCodeError: false, errorMessageProcess: 'Your bank has declined the charge due to Insufficient Funds. Please call the number on the back of your card.' })
            case 'Card Not Activated':
            return this.setState({ loading: false, postalCodeError: false, errorMessageProcess: 'The card number you have entered has not been activated for payments or transactions. Please call the number on the back of your card.' })
            case "Expired Card":
            return this.setState({ loading: false, postalCodeError: false, errorMessageProcess: 'Invalid expiration date.' })
        }
        if(result.error === 'Do Not Honor' || result.error === 'Processor Network Unavailable - Try Again'
        || result.error === 'Processor Declined - Fraud Suspected' || result.error === 'Declined - Call Issuer' || result.error === 'Cannot Authorize at this time (Policy)'
        || result.error === 'Card Issuer Declined CVV' || result.error === 'Gateway Rejected: risk_threshold' || result.error === 'Cannot Authorize at this time (Life cycle)'
        || !_.isEmpty(result.error)) {
            return this.setState({ loading: false, postalCodeError: false, errorMessageProcess: 'Your bank has rejected the charge. Please call the number on the back of your card.' })
        }
        AppCache.setOrderInfo(result)
        this.setState({ loading: false })
        if (result.message || result.errorMessage) {
            this.setState({ visible: true })
        }
        const query = new URLSearchParams(window.location.search);
        let writerNumber = query.get('writer_type');
        const search = result.ifUserExist == false ? `userExist=0&writer_type=${writerNumber}` : `email=${result.emailId}&userExist=1&writer_type=${writerNumber}`;
        this.props.navigate(`${constants.MW3NewViewOrderURL}?${search}`);
        } finally {
            this.orderInFlight = false;
        }
    }

    async discountCalculation(discountCouponNumber, license) {
        let [oneYearDiscountAmt, twoYearDiscountAmt, recurringDiscountAmt] = Array(3).fill(0);
        if (discountCouponNumber.includes("DF"))
            var oneYearDiscountCode = discountCouponNumber
        else
            var oneYearDiscountCode = ONE_YEAR_DISCOUNT_PREFIX + discountCouponNumber;
        if (discountCouponNumber.includes("DS"))
            var twoYearDiscountCode = discountCouponNumber
        else
            var twoYearDiscountCode = TWO_YEAR_DISCOUNT_PREFIX + discountCouponNumber;
        if (discountCouponNumber.includes("DR"))
            var recurringDiscountCode = discountCouponNumber
        else
            var recurringDiscountCode = MW3_MONTLY_DISCOUNT_PREFIX + discountCouponNumber;
        let discountFetch = {
            oneYearDiscountCode: oneYearDiscountCode,
            twoYearDiscountCode: twoYearDiscountCode,
            recurringDiscountCode: recurringDiscountCode,
        }
        let discountAmt = await DiscountApi.findDiscountByDiscountCode(discountFetch)
        discountAmt.map(item => {
            if (item.code.includes("DF")) {
                oneYearDiscountAmt = item.value;
            } else if (item.code.includes("DS")) {
                twoYearDiscountAmt = item.value;
            } else if (item.code.includes("DR")) {
                recurringDiscountAmt = item.value;
            }
        })
        //if (license.includeMonthly) {
        // let recurringDiscountCode = MW3_MONTLY_DISCOUNT_PREFIX + discountCouponNumber;
        // let recurringDiscountAmt = await DiscountApi.findDiscountByDiscountCode(recurringDiscountCode)
        // console.log(recurringDiscountAmt + "constant " + constants.MonthlyLicenseAmount)
        // license.licenses[0].discountAmount = (constants.MonthlyLicenseAmount - parseFloat(recurringDiscountAmt || 0)).toFixed(2);
        // license.licenses[1].discountAmount = (constants.OneYearLicenseAmount - parseFloat(oneYearDiscountAmt || 0)).toFixed(2);
        // license.licenses[2].discountAmount = (constants.TwoYearLicenseAmount - parseFloat(twoYearDiscountAmt || 0)).toFixed(2);
        //}
        //else {
        let path = window.location.pathname
        let result = path.split('/')
        let routeParams = result[result.length - 1].split('.')[0]
        if (routeParams == 'DiscountOneYearCWNewlicenseOrder' || routeParams == 'DiscountOneYearSWNewlicenseOrder') {
            license.licenses[0].discountAmount = (constants.OneYearLicenseAmount - parseFloat(oneYearDiscountAmt || 0)).toFixed(2);
        }
        else if (routeParams == 'DiscountTwoYearCWNewlicenseOrder' || routeParams == 'DiscountTwoYearSWNewlicenseOrder') {
            license.licenses[0].discountAmount = (constants.TwoYearLicenseAmount - parseFloat(twoYearDiscountAmt || 0)).toFixed(2);
            //console.log(TwoYearLicenseAmount)
        }
        else if (routeParams == 'DiscountRecurringSWNewLicenseOrder' || routeParams == 'DiscountRecurringCWNewLicenseOrder') {
            license.licenses[0].discountAmount = (constants.MonthlyLicenseAmount - parseFloat(recurringDiscountAmt || 0)).toFixed(2);
            //console.log(license.licenses[0].discountAmount)
        }
        else if (routeParams == 'Discount1RecurringSWNewLicenseOrder' || routeParams == 'Discount1RecurringCWNewLicenseOrder') {
            license.licenses[0].discountAmount = (constants.MonthlyLicenseAmount - parseFloat(recurringDiscountAmt || 0)).toFixed(2);
            //console.log(license.licenses[0].discountAmount)
        }
        //license.licenses[1].discountAmount = (constants.TwoYearLicenseAmount - parseFloat(twoYearDiscountAmt || 0)).toFixed(2);
        //}
        this.setState({ discountCouponNumber: discountCouponNumber, discountAmount: license.licenses[0].discountAmount, oneYearDiscountAmt, twoYearDiscountAmt, recurringDiscountAmt, recurringDiscountCode, oneYearDiscountCode, twoYearDiscountCode })
    }

    async componentDidMount() {
        this.init();
        const query = new URLSearchParams(window.location.search);
        document.title =  (query.get('writer_type') == 1) ? 'Order | MasterWriter for Creative Writing' : 'Order | MasterWriter for Songwriting';
        let path = window.location.pathname
        let result = path.split('/')
        let routeParams = result[result.length - 1].split('.')[0]
        var res = AppCache.getRedeemData();
        const discountCouponNumber = query.get('dcn');
        if (query.get('flag')) {
            if (res.writerType == 1) {
                routeParams = 'MW2ToMW3UpgradeCWNewlicenseOrder'
            } else if (res.writerType == 2) {
                routeParams = 'MW2ToMW3UpgradeSWNewlicenseOrder'
            }
        }
        let license = await LicenseApi.findLicenseByRoute(routeParams)


        // if(routeParams === 'SWNewlicenseOrder')
        // {
        //      oneYearLicense = license.licenses[1].price
        //      console.log(oneYearLicense)
        // }
        //console.log(license.licenses[0].price)
        if (discountCouponNumber) {
            this.discountCalculation(discountCouponNumber, license)
        }
        this.setState({ clientToken: '', licenses: license.licenses, selectedLicense: license.licenses[0], discountEnable: license.discountEnable, includeMonthly: license.includeMonthly, license: license })
        // Ensure right-side background image shows when lazyload does not run (localhost vs integration)
        const publicUrl = process.env.PUBLIC_URL || '';
        const styleId = 'order-page-background-overrides';
        if (!document.getElementById(styleId)) {
            const style = document.createElement('style');
            style.id = styleId;
            style.textContent = `@media (min-width: 1025px) {
.elementor-10384 .elementor-element.elementor-element-e95eb64:not(.elementor-motion-effects-element-type-background),
.elementor-10384 .elementor-element.elementor-element-e95eb64 > .elementor-motion-effects-container > .elementor-motion-effects-layer {
  background-image: var(--e-bg-lazyload-loaded, url(${publicUrl}/images/home-right-moon@2x.png));
  background-position: top right;
  background-repeat: no-repeat;
  background-size: 46px auto;
}
.elementor-10384 .elementor-element.elementor-element-e88c461:not(.elementor-motion-effects-element-type-background) > .elementor-widget-wrap,
.elementor-10384 .elementor-element.elementor-element-e88c461 > .elementor-widget-wrap > .elementor-motion-effects-container > .elementor-motion-effects-layer {
  background-image: var(--e-bg-lazyload-loaded, url(${publicUrl}/images/vertical_3.png));
  background-position: -12px 2px;
  background-repeat: no-repeat;
}
}`;
            document.head.appendChild(style);
            this._orderPageOverrideStyle = style;
        }
    }

    componentWillUnmount() {
        if (this._formElement && this._submitHandler) {
            this._formElement.removeEventListener('submit', this._submitHandler, false);
            this._formElement = null;
            this._submitHandler = null;
        }
        if (this._orderPageOverrideStyle && this._orderPageOverrideStyle.parentNode) {
            this._orderPageOverrideStyle.parentNode.removeChild(this._orderPageOverrideStyle);
        }
    }

    createProductConfiguration = (product, license) => {
        let licensies;
        product.licensies && product.licensies.map((l) => {
            if (l.id == license.licenseId)
                licensies = l
        })
        let productConf = {
            trial: licensies.trial == 1,
            description: '',
            price: license.price,
            subscriptionUnit: licensies.subscriptionUnit,
            subscriptionLength: licensies.subscriptionLength,
            productCode: license.productCode,
            productName: license.productCode,
            productPrice: license.price

        }
        return productConf
    }

    renderSwitch(index) {
        switch (index) {
            case 0:
                return (
                    <></>
                )
            case 1:
                return (
                    <span className='small-amount'>($8.33 per month)</span>
                )
            case 2:
                return (
                    <span className='small-amount'>($6.25 per month)</span>
                )
            default:
                return <></>;
        }
    }


    renderSwitch2(septToOct, beforeSept) {
        // console.log(upgradeProcessType,septToOct,beforeSept)
        var res = AppCache.getRedeemData();
        switch (res.upgradeProcessType) {
            case 'UNLIMITED_IN_1_SEPT_30_OCT_LICENSE':
                return (<>${septToOct} </>)
            case 'UNLIMITED_BEFORE_1_SEPT_LICENSE':
                return (<>${beforeSept}</>)
        }
    }
    show() {
        this.setState({ visible: false })
    }

    render() {
        const { licenses = [], license, loading, discountEnable, includeMonthly, discountCouponNumber, flag, oneYearDiscountAmt, twoYearDiscountAmt, recurringDiscountAmt, showSidebar, showText, cardError: tokenErrorCard, cvvError: tokenErrorCvv, monthYearError: tokenErrorExptMonthYear, errorMessageProcess, recurringDiscountCode, oneYearDiscountCode, twoYearDiscountCode, formValidationState, postalCodeError } = this.state
        let path = window.location.pathname
        let result = path.split('/')
        let routeParams = result[result.length - 1].split('.')[0]
        let licenseTypePage = routeParams.substr(0, 2)
        let licenseTypeDisRecurringPage = routeParams.substring(17, 19)
        let licenseTypeOneYearRecurringPage = routeParams.substring(15, 17)
        let licenseTypeTrialDiscount = routeParams.substring(18, 20)
        return (
            <>
                <Header />
                {loading && <div className="dark-background">
                    <LoadingOverlay className="_loading_overlay_content" active={loading} spinner
                        text={showText ? '' : 'Processing...'}></LoadingOverlay>
                </div>}

                <main id="content" className="site-main post-10384 page type-page status-publish hentry">
                    <div className="page-content">
                        <div data-elementor-type="wp-page" data-elementor-id="10384" className="elementor elementor-10384"
                            data-elementor-post-type="page">
                            <section
                                className="elementor-section elementor-top-section elementor-element elementor-element-5b80617 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                                data-id="5b80617" data-element_type="section"
                                data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
                                <div className="elementor-container elementor-column-gap-default">
                                    <div className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-21feb1f"
                                        data-id="21feb1f" data-element_type="column"
                                        data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
                                        <div className="elementor-widget-wrap elementor-element-populated">
                                            <div className="elementor-element elementor-element-7f33ca0 elementor-widget elementor-widget-heading"
                                                data-id="7f33ca0" data-element_type="widget" data-widget_type="heading.default">
                                                <div className="elementor-widget-container">
                                                    <h1 className="elementor-heading-title elementor-size-default">Complete Your Order
                                                    </h1>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                            <section
                                className="elementor-section elementor-top-section elementor-element elementor-element-e95eb64 elementor-section-full_width elementor-section-height-default elementor-section-height-default"
                                data-id="e95eb64" data-element_type="section"
                                data-settings="{&quot;background_background&quot;:&quot;classic&quot;}" data-e-bg-lazyload="">
                                <div className="elementor-container elementor-column-gap-default">
                                    <div className="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-bfdbe4f elementor-hidden-tablet elementor-hidden-mobile"
                                        data-id="bfdbe4f" data-element_type="column">
                                        <div className="elementor-widget-wrap elementor-element-populated">
                                            <div className="elementor-element elementor-element-32c1f3f elementor-widget elementor-widget-image"
                                                data-id="32c1f3f" data-element_type="widget" data-widget_type="image.default">
                                                <div className="elementor-widget-container"> <LazyLoad width="103"
                                                    height="849"><img decoding="async"  src={`${process.env.PUBLIC_URL || ''}/images/2022-08-home-left-moon@2x.png`}
                                                    className="attachment-large size-large wp-image-8556" alt="" loading="lazy" />
                                                    </LazyLoad>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-3de53ed"
                                        data-id="3de53ed" data-element_type="column"
                                        data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
                                        <div className="elementor-widget-wrap elementor-element-populated">
                                            <form className="elementor-form elementor-section elementor-inner-section elementor-element elementor-element-e73911b elementor-section-boxed elementor-section-height-default elementor-section-height-default" id="my-sample-form" ref={this.form}>
                                                <section
                                                    className="elementor-section elementor-inner-section elementor-element elementor-element-e73911b elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                                                    data-id="e73911b" data-element_type="section"
                                                    data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
                                                    <div className="elementor-container elementor-column-gap-default">
                                                        <div className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-e88c461"
                                                            data-id="e88c461" data-element_type="column"
                                                            data-settings="{&quot;background_background&quot;:&quot;classic&quot;}"
                                                            data-e-bg-lazyload=".elementor-element-populated">
                                                            <div className="elementor-widget-wrap elementor-element-populated">
                                                                <div className="elementor-element elementor-element-592d868 elementor-button-align-end mw-order-form elementor-widget elementor-widget-form"
                                                                    data-id="592d868" data-element_type="widget" id="sw-order-form"
                                                                    data-settings="{&quot;step_next_label&quot;:&quot;Next&quot;,&quot;step_previous_label&quot;:&quot;Previous&quot;,&quot;step_type&quot;:&quot;number_text&quot;,&quot;step_icon_shape&quot;:&quot;circle&quot;}"
                                                                    data-widget_type="form.default">
                                                                    <div className="elementor-widget-container">
                                                                        <input type="hidden" name="post_id" value="10384" /> <input
                                                                            type="hidden" name="form_id" value="592d868" /> <input
                                                                            type="hidden" name="referer_title"
                                                                            value="SW_Order_Form" /> <input type="hidden"
                                                                                name="queried_id" value="10384" />
                                                                        <div
                                                                            className="elementor-form-fields-wrapper elementor-labels- payment-method-lable">
                                                                            <div
                                                                                className="elementor-field-type-text elementor-field-group elementor-column elementor-field-group-field_2df512b elementor-col-50 elementor-field-required">
                                                                                <label htmlFor="form-field-field_2df512b"
                                                                                    className="elementor-field-label elementor-screen-only">
                                                                                    First Name </label> <input ref={firstName => this.firstName = firstName} type="text"
                                                                                        id="firstName" name="firstName"
                                                                                        className="elementor-field validate elementor-size-xs  elementor-field-textual"
                                                                                        placeholder="First Name" required="required"
                                                                                        aria-required="true" maxLength="50" onChange={this.handleChange.bind(this)} /> </div>
                                                                            <div
                                                                                className="elementor-field-type-text elementor-field-group elementor-column elementor-field-group-field_5ddb86c elementor-col-50 elementor-field-required">
                                                                                <label htmlFor="form-field-field_5ddb86c"
                                                                                    className="elementor-field-label elementor-screen-only">
                                                                                    Last Name </label> <input ref={lastName => this.lastName = lastName} type="text"
                                                                                        id="lastName" name="lastName"
                                                                                        className="elementor-field validate1 elementor-size-xs  elementor-field-textual"
                                                                                        placeholder="Last Name" required="required"
                                                                                        aria-required="true" maxLength="50" onChange={this.handleChange.bind(this)} /> </div>
                                                                            <div
                                                                                className="elementor-field-type-text elementor-field-group elementor-column elementor-field-group-field_2b17be1 elementor-col-100">
                                                                                <label htmlFor="form-field-field_2b17be1"
                                                                                    className="elementor-field-label elementor-screen-only">
                                                                                    Address Line 1 </label> <input ref={addressOne => this.addressOne = addressOne}
                                                                                        type="text" id="addressOne" name="addressOne"
                                                                                        className="elementor-field validate2 elementor-size-xs  elementor-field-textual" required="required"
                                                                                        maxLength="100" placeholder="Address Line 1" onChange={this.handleChange.bind(this)} /> </div>
                                                                            <div
                                                                                className="elementor-field-type-text elementor-field-group elementor-column elementor-field-group-field_dc572c3 elementor-col-100">
                                                                                <label htmlFor="form-field-field_dc572c3"
                                                                                    className="elementor-field-label elementor-screen-only">
                                                                                    Address Line 2 </label> <input size="1"
                                                                                        type="text" name="addressTwo" placeholder="Address Line 2" maxLength="50" onChange={this.handleChange.bind(this)}
                                                                                        className="elementor-field elementor-size-xs  elementor-field-textual"
                                                                                /> </div>
                                                                            <div
                                                                                className="elementor-field-type-text elementor-field-group elementor-column elementor-field-group-field_c8f64a7 elementor-col-50">
                                                                                <label htmlFor="form-field-field_c8f64a7"
                                                                                    className="elementor-field-label elementor-screen-only">
                                                                                    City </label> <input ref={city => this.city = city} type="text" required="required"
                                                                                        id="city" name="city"
                                                                                        className="elementor-field validate3 elementor-size-xs  elementor-field-textual"
                                                                                        placeholder="City" maxLength="50" onChange={this.handleChange.bind(this)} /> </div>
                                                                            <div
                                                                                className="elementor-field-type-text elementor-field-group elementor-column elementor-field-group-field_6cc2c8f elementor-col-50">
                                                                                <label htmlFor="form-field-field_6cc2c8f"
                                                                                    className="elementor-field-label elementor-screen-only">
                                                                                    State/Province </label> <input ref={stateVal => this.stateVal = stateVal} required="required"
                                                                                        type="text" id="state" name="state"
                                                                                        className="elementor-field validate4 elementor-size-xs  elementor-field-textual"
                                                                                        placeholder="State/Province" maxLength="50" onChange={this.handleChange.bind(this)} /> </div>
                                                                            <div
                                                                                className="elementor-field-type-text elementor-field-group elementor-column elementor-field-group-field_3aa86d3 elementor-col-50">
                                                                                <label htmlFor="form-field-field_3aa86d3"
                                                                                    className="elementor-field-label validate5 elementor-screen-only">
                                                                                    Zip/Postal </label> <input ref={zip => this.zip = zip} type="text" required="required"
                                                                                        id="zip" name="zip"
                                                                                        className={this.state.postalCodeError ? '' : 'elementor-field elementor-size-xs  elementor-field-textual wpcf7-form-control input-zip'} style={this.state.postalCodeError ? { border: '3px solid red', width: '100%' } : { width: '100%' }} size="40" placeholder="Zip/Postal" maxLength="20" onChange={this.handleChange.bind(this)}
                                                                                /> </div>
                                                                            <div
                                                                                className="elementor-field-type-select elementor-field-group elementor-column elementor-field-group-countryList elementor-col-50">
                                                                                <label htmlFor="form-field-countryList"
                                                                                    className="elementor-field-label validate6 elementor-screen-only">
                                                                                    Country </label>
                                                                                <div
                                                                                    className="elementor-field elementor-select-wrapper remove-before" style={{ height: '42px' }}>
                                                                                    <div className="select-caret-down-wrapper country-select"> <svg viewBox="0 0 571.4 571.4" style={{ marginTop: '5px' }}>
                                                                                        <path
                                                                                            d="M571 393Q571 407 561 418L311 668Q300 679 286 679T261 668L11 418Q0 407 0 393T11 368 36 357H536Q550 357 561 368T571 393Z"
                                                                                            fill="white"
                                                                                            stroke="white"

                                                                                        />
                                                                                    </svg></div>
                                                                                    <select style={{ color: '#aaa9a9' }}
                                                                                        name="country" placeholder="Select Country"
                                                                                        onChange={this.handleChange.bind(this)}
                                                                                        className="elementor-field elementor-size-xs elementor-field-textual wpcf7-form-control input-zip" required="required">
                                                                                        {countries.map(country =>
                                                                                            <option autoFocus className="select-limit" key={country.name} value={country.value}>{country.name}</option>
                                                                                        )};
                                                                                    </select>
                                                                                </div>
                                                                            </div>
                                                                            <div
                                                                                className="elementor-field-type-email elementor-field-group elementor-column elementor-field-group-email elementor-col-60 elementor-field-required">
                                                                                <label htmlFor="form-field-email"
                                                                                    className="elementor-field-label elementor-screen-only">
                                                                                    Email </label>                                                                                 <input ref={email => this.email = email} type="email"
                                                                                        pattern="[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,3}"
                                                                                        id="email" name="email"
                                                                                        className="elementor-field validate7 elementor-size-xs  elementor-field-textual"
                                                                                        size="40" placeholder="Email" maxLength="75" onChange={this.handleChange.bind(this)}
                                                                                        aria-required="true" required="required" /> </div>
                                                                            <div
                                                                                className="elementor-field-type-tel elementor-field-group elementor-column elementor-field-group-field_c8b1a5f elementor-col-40 elementor-field-required">
                                                                                <label htmlFor="form-field-field_c8b1a5f"
                                                                                    className="elementor-field-label elementor-screen-only">
                                                                                    Phone </label> <input ref={phone => this.phone = phone} type="tel"
                                                                                        id="phone" name="phone"
                                                                                        className="elementor-field validate8 elementor-size-xs  elementor-field-textual"
                                                                                        required="required"
                                                                                        aria-required="true"
                                                                                        pattern="[0-9()#&amp;+*-=.]+"
                                                                                        title="Only numbers and phone characters (#, -, *, etc) are accepted."
                                                                                        size="40" placeholder="Phone" maxLength="25" onChange={this.handleChange.bind(this)} />
                                                                            </div>
                                                                            <div
                                                                                className="elementor-field-type-textarea elementor-field-group elementor-column elementor-field-group-message elementor-col-100">
                                                                                <label htmlFor="form-field-message"
                                                                                    className="elementor-field-label elementor-screen-only">
                                                                                    Message </label> <textarea
                                                                                        className="elementor-field-textual elementor-field  elementor-size-xs"
                                                                                        name="howDidYouHear"
                                                                                        id="form-field-message" rows="2"
                                                                                        placeholder="How did you hear about MasterWriter?" maxLength="1024" title="HOW DID YOU HEAR ABOUT MASTERWRITER?" onChange={this.handleChange.bind(this)}></textarea>
                                                                            </div>
                                                                            {discountEnable && !flag && routeParams == 'DiscountRecurringCWNewLicenseOrder' || routeParams == 'DiscountRecurringSWNewLicenseOrder' ?
                                                                                <p>
                                                                                    <span className="wpcf7-form-control-wrap clearfix">
                                                                                        <input ref={recurringDiscountCode => this.recurringDiscountCode = recurringDiscountCode} type="text" id="discountCode" name="discount" className="wpcf7-form-control wpcf7-text input-zip discount-apply-field" size="40" placeholder="Discount Code" defaultValue={recurringDiscountCode} onChange={this.handlechangeDiscount.bind(this)} style={{ width: '57.5%', background: '#2E313C', marginLeft: '8px', color: '#a7a7a7', borderWidth: '0px 0px 0px 0px', padding: '8px 12px 4px 12px', height: '40px', borderRadius: '2px' }} />
                                                                                        <input className="fusion-button button-flat fusion-button-square button-large button-blue button-1 input-country discount-apply-field discount-apply-button" style={{ height: '40px', paddingTop: '3px', paddingBottom: 0, marginLeft: '11px', width: '38%' }} name="text" value="Apply Discount" size="40" type="button" onClick={this.submitFormtoApplyDiscount.bind(this)}></input>
                                                                                    </span>
                                                                                </p> : null}
                                                                            {discountEnable && !flag && routeParams == 'DiscountOneYearCWNewlicenseOrder' || routeParams == 'DiscountOneYearSWNewlicenseOrder' ?
                                                                                <p>
                                                                                    <span className="wpcf7-form-control-wrap clearfix">
                                                                                        <input ref={discountCode => this.discountCode = discountCode} type="text" id="discountCode" name="discount" className="wpcf7-form-control wpcf7-text input-zip discount-apply-field" size="40" placeholder="Discount Code" defaultValue={oneYearDiscountCode} onChange={this.handlechangeDiscount.bind(this)} style={{ width: '57.5%', background: '#2E313C', marginLeft: '8px', color: '#a7a7a7', borderWidth: '0px 0px 0px 0px', padding: '8px 12px 4px 12px', height: '40px', borderRadius: '2px' }} />

                                                                                        <input aria-invalid="false" aria-required="true" className="fusion-button button-flat fusion-button-square button-large button-blue button-1 input-country discount-apply-field discount-apply-button" name="text" value="Apply Discount" size="40" type="button" onClick={this.submitFormtoApplyDiscount.bind(this)} style={{ height: '40px', paddingTop: '3px', paddingBottom: 0, marginLeft: '11px', width: '38%' }}></input>
                                                                                    </span>
                                                                                </p> : null}
                                                                            {discountEnable && !flag && routeParams == 'DiscountTwoYearCWNewlicenseOrder' || routeParams == 'DiscountTwoYearSWNewlicenseOrder' ? <p>
                                                                                <span className="wpcf7-form-control-wrap clearfix">
                                                                                    <input ref={discountCode => this.discountCode = discountCode} type="text" id="discountCode" name="discount" className="wpcf7-form-control wpcf7-text input-zip discount-apply-field" size="40" placeholder="Discount Code" defaultValue={twoYearDiscountCode} onChange={this.handlechangeDiscount.bind(this)} style={{ width: '57.5%', background: '#2E313C', marginLeft: '8px', color: '#a7a7a7', borderWidth: '0px 0px 0px 0px', padding: '8px 12px 4px 12px', height: '40px', borderRadius: '2px' }} />

                                                                                    <input aria-invalid="false" aria-required="true" className="fusion-button button-flat fusion-button-square button-large button-blue button-1 input-country discount-apply-field discount-apply-button" style={{ height: '40px', paddingTop: '3px', paddingBottom: 0, marginLeft: '11px', width: '38%' }} name="text" value="Apply Discount" size="40" type="button" onClick={this.submitFormtoApplyDiscount.bind(this)} ></input>
                                                                                </span>
                                                                            </p> : null}

                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-2eee44a"
                                                            data-id="2eee44a" data-element_type="column">
                                                            <div className="elementor-widget-wrap elementor-element-populated" style={{ display: showSidebar ? 'block' : 'none' }}>
                                                                <div className="elementor-element elementor-element-e0070e2 elementor-widget elementor-widget-html license-price-responsive"
                                                                    data-id="e0070e2" data-element_type="widget"
                                                                    data-widget_type="html.default">
                                                                    <div className="elementor-widget-container">
                                                                        {licenses.length && licenses.map((license, index) => (
                                                                            <div key={index} className="order-info">
                                                                                {index == 0 && routeParams == 'SWOneYearNewlicenseOrder' ?
                                                                                    <div key="sw-one-year" style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                                                                        <div className="license">1 Year License</div>
                                                                                        <div className="license-cost">${license.price}</div>
                                                                                    </div> : null
                                                                                }
                                                                                {index == 0 && routeParams == 'CWOneYearNewlicenseOrder' ?
                                                                                    <div key="cw-one-year" style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                                                                        <div className="license">1 Year License</div>
                                                                                        <div className="license-cost">${license.price}</div>
                                                                                    </div> : null
                                                                                }
                                                                                {index == 0 && routeParams == 'CWRecurringNewLicenseOrder' ?
                                                                                    <div key="cw-recurring" style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                                                                        <div className="license">Monthly License</div>
                                                                                        <div className="license-cost">${license.price}</div>
                                                                                    </div> : null
                                                                                }
                                                                                {index == 0 && routeParams == 'SWRecurringNewLicenseOrder' ?
                                                                                    <div key="sw-recurring" style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                                                                        <div className="license">Monthly License</div>
                                                                                        <div className="license-cost">${license.price}</div>
                                                                                    </div> : null
                                                                                }
                                                                                {index == 0 && routeParams == 'CWTwoYearNewlicenseOrder' ?
                                                                                    <div key="cw-two-year" style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                                                                        <div className="license">2-Year License</div>
                                                                                        <div className="license-cost">${license.price}</div>
                                                                                    </div> : null
                                                                                }
                                                                                {index == 0 && routeParams == 'SWTwoYearNewlicenseOrder' ?
                                                                                    <div key="sw-two-year" style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                                                                                        <div className="license">2-Year License</div>
                                                                                        <div className="license-cost">${license.price}</div>
                                                                                    </div> : null
                                                                                }
                                                                            </div>
                                                                        ))}
                                                                        {licenses.length && licenses.map((license, index) => (
                                                                            <div key={index} className="row-disc-product">
                                                                                {discountEnable && routeParams == 'DiscountOneYearSWNewlicenseOrder' && !flag ?
                                                                                    <>
                                                                                        <div className="product-info-dis-title">
                                                                                            <span className="license" style={{ fontSize: '24px' }}>1 Year License</span>
                                                                                            <span className="license-cost" style={{ float: 'right', fontSize: '24px' }}>${license.price}</span>
                                                                                        </div>
                                                                                        <div className="product-info-dis-title">
                                                                                            <span className="license" style={{ fontSize: '24px' }}>Discount</span>
                                                                                            <span className="license-cost" style={{ float: 'right', fontSize: '24px' }}>${parseFloat(oneYearDiscountAmt || 0).toFixed(2)}</span>
                                                                                        </div>
                                                                                        <div className="product-info-dis-title">
                                                                                            <span className="license" style={{ fontSize: '24px' }}>Total</span>
                                                                                            <span className="license-cost" style={{ float: 'right', fontSize: '24px' }}>${license.discountAmount}</span>
                                                                                        </div>
                                                                                    </> : null
                                                                                }
                                                                                {discountEnable && routeParams == 'DiscountOneYearCWNewlicenseOrder' && !flag ?
                                                                                    <>
                                                                                        <div className="product-info-dis-title">
                                                                                            <span className="license">1 Year License</span>
                                                                                            <span className="license-cost" style={{ float: 'right' }}>${license.price}</span>
                                                                                        </div>
                                                                                        <div className="product-info-dis-title">
                                                                                            <span className="license">Discount</span>
                                                                                            <span className="license-cost" style={{ float: 'right' }}>${parseFloat(oneYearDiscountAmt || 0).toFixed(2)}</span>
                                                                                        </div>
                                                                                        <div className="product-info-dis-title">
                                                                                            <span className="license">Total</span>
                                                                                            <span className="license-cost" style={{ float: 'right' }}>${license.discountAmount}</span>
                                                                                        </div>
                                                                                    </> : null
                                                                                }
                                                                                {discountEnable && routeParams == 'DiscountTwoYearCWNewlicenseOrder' && !flag ?
                                                                                    <>
                                                                                        <div className="product-info-dis-title">
                                                                                            <span className="license">2 Year License</span>
                                                                                            <span className="license-cost" style={{ float: 'right' }}>${license.price}</span>
                                                                                        </div>
                                                                                        <div className="product-info-dis-title">
                                                                                            <span className="license">Discount</span>
                                                                                            <span className="license-cost" style={{ float: 'right' }}>${parseFloat(twoYearDiscountAmt || 0).toFixed(2)}</span>
                                                                                        </div>
                                                                                        <div className="product-info-dis-title">
                                                                                            <span className="license">Total</span>
                                                                                            <span className="license-cost" style={{ float: 'right' }}>${license.discountAmount}</span>
                                                                                        </div>
                                                                                    </> : null
                                                                                }
                                                                                {discountEnable && routeParams == 'DiscountTwoYearSWNewlicenseOrder' && !flag ?
                                                                                    <>
                                                                                        <div className="product-info-dis-title">
                                                                                            <span className="license">2 Year License</span>
                                                                                            <span className="license-cost" style={{ float: 'right' }}>${license.price}</span>
                                                                                        </div>
                                                                                        <div className="product-info-dis-title">
                                                                                            <span className="license">Discount</span>
                                                                                            <span className="license-cost" style={{ float: 'right' }}>${parseFloat(twoYearDiscountAmt || 0).toFixed(2)}</span>
                                                                                        </div>
                                                                                        <div className="product-info-dis-title">
                                                                                            <span className="license">Total</span>
                                                                                            <span className="license-cost" style={{ float: 'right' }}>${license.discountAmount}</span>
                                                                                        </div>
                                                                                    </> : null
                                                                                }
                                                                                {discountEnable && routeParams == 'DiscountRecurringCWNewLicenseOrder' && !flag ?
                                                                                    <>
                                                                                        <div className="product-info-dis-title">
                                                                                            <span className="license">Monthly License</span>
                                                                                            <span className="license-cost" style={{ float: 'right' }}>${license.price}</span>
                                                                                        </div>
                                                                                        <div className="product-info-dis-title">
                                                                                            <span className="license">Discount</span>
                                                                                            <span className="license-cost" style={{ float: 'right' }}>${parseFloat(recurringDiscountAmt || 0).toFixed(2)}</span>
                                                                                        </div>
                                                                                        <div className="product-info-dis-title">
                                                                                            <span className="license">Total</span>
                                                                                            <span className="license-cost" style={{ float: 'right' }}>${license.discountAmount}</span>
                                                                                        </div>
                                                                                    </> : null
                                                                                }
                                                                                {discountEnable && routeParams == 'DiscountRecurringSWNewLicenseOrder' && !flag ?
                                                                                    <>
                                                                                        <div className="product-info-dis-title">
                                                                                            <span className="license">Monthly License</span>
                                                                                            <span className="license-cost" style={{ float: 'right' }}>${license.price}</span>
                                                                                        </div>
                                                                                        <div className="product-info-dis-title">
                                                                                            <span className="license">Discount</span>
                                                                                            <span className="license-cost" style={{ float: 'right' }}>${parseFloat(recurringDiscountAmt || 0).toFixed(2)}</span>
                                                                                        </div>
                                                                                        <div className="product-info-dis-title">
                                                                                            <span className="license">Total</span>
                                                                                            <span className="license-cost" style={{ float: 'right' }}>${license.discountAmount}</span>
                                                                                        </div>
                                                                                    </> : null
                                                                                }
                                                                                {discountEnable && includeMonthly && routeParams == 'Discount1RecurringSWNewLicenseOrder' && !flag ?
                                                                                    <>
                                                                                        <div className="product-info-dis-title">
                                                                                            <span className="license">Monthly License</span>
                                                                                            <span className="license-cost" style={{ float: 'right' }}>${license.price}</span>
                                                                                        </div>
                                                                                        <div className="product-info-dis-title">
                                                                                            <span className="license">Discount</span>
                                                                                            <span className="license-cost" style={{ float: 'right' }}>${parseFloat(recurringDiscountAmt || 0).toFixed(2)}</span>
                                                                                        </div>
                                                                                        <div className="product-info-dis-title">
                                                                                            <span className="license">Total</span>
                                                                                            <span className="license-cost" style={{ float: 'right' }}>${license.discountAmount}</span>
                                                                                        </div>
                                                                                    </> : null
                                                                                }
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                </div>

                                                                <div className="elementor-element elementor-element-e6994ce elementor-widget-divider--view-line_text elementor-widget-divider--element-align-left elementor-widget elementor-widget-divider" data-id="e6994ce" data-element_type="widget" data-widget_type="divider.default">
                                                                    <div className="elementor-widget-container">
                                                                        <div className="elementor-divider">
                                                                            <span className="elementor-divider-separator">
                                                                                <span className="elementor-divider__text elementor-divider__element"> Methods of payment accepted</span>
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                </div>


                                                                <div className="elementor-element elementor-element-d8d530c elementor-widget elementor-widget-image"
                                                                    data-id="d8d530c" data-element_type="widget"
                                                                    data-widget_type="image.default">
                                                                    <div className="elementor-widget-container"><img decoding="async"
                                                                        width="633" height="100" src="./images/2022-10-credit-cards-logo.png"
                                                                        className="attachment-large size-large wp-image-10391" alt=""
                                                                        loading="lazy"
                                                                        srcSet="./images/2022-10-credit-cards-logo.png 633w, ./images/2022-10-credit-cards-logo-300x47.png 300w"
                                                                        sizes="(max-width: 633px) 100vw, 633px" /> </div>
                                                                </div>
                                                                <div className="elementor-element elementor-element-e4e681d elementor-button-align-stretch elementor-widget elementor-widget-form"
                                                                    data-id="e4e681d" data-element_type="widget"
                                                                    data-settings="{&quot;step_next_label&quot;:&quot;Next&quot;,&quot;step_previous_label&quot;:&quot;Previous&quot;,&quot;button_width&quot;:&quot;100&quot;,&quot;step_type&quot;:&quot;number_text&quot;,&quot;step_icon_shape&quot;:&quot;circle&quot;}"
                                                                    data-widget_type="form.default" style={{ marginBottom: '30px' }}>
                                                                    <div className="elementor-widget-container">
                                                                        <div className="elementor-form" name="Fake">
                                                                            <div
                                                                                className="elementor-form-fields-wrapper elementor-labels-">
                                                                                <div
                                                                                    className="elementor-field-type-text elementor-field-group elementor-column elementor-field-group-name elementor-col-100">

                                                                                    <label htmlFor="card-number" className="wpcf7-form-control hosted-field-label">Card Number</label>
                                                                                    <div id="card-number"
                                                                                        className="hosted-field elementor-field elementor-size-sm  elementor-field-textual"
                                                                                        placeholder="ENTER CREDIT CARD NUMBER" /> </div>
                                                                                <div
                                                                                    className="elementor-field-type-select elementor-field-group elementor-column elementor-field-group-field_7a8b0cf elementor-col-33 mobile-card-details">

                                                                                    <div className="elementor-field elementor-select-wrapper remove-before">
                                                                                        <div className="select-caret-down-wrapper"> <svg viewBox="0 0 571.4 571.4">
                                                                                            <path
                                                                                                d="M571 393Q571 407 561 418L311 668Q300 679 286 679T261 668L11 418Q0 407 0 393T11 368 36 357H536Q550 357 561 368T571 393Z"
                                                                                                fill="black"
                                                                                                stroke="black"
                                                                                            />
                                                                                        </svg>
                                                                                        </div>
                                                                                        <div id="expiration-month" className="hosted-field-month elementor-field-textual elementor-size-sm" style={{ background: 'white', padding: '0px' }}></div>

                                                                                    </div>
                                                                                </div>
                                                                                <div
                                                                                    className="elementor-field-type-select elementor-field-group elementor-column elementor-field-group-field_7a8b0cf elementor-col-33 mobile-card-details">

                                                                                    <div className="elementor-field elementor-select-wrapper remove-before">
                                                                                        <div className="select-caret-down-wrapper"> <svg viewBox="0 0 571.4 571.4">
                                                                                            <path
                                                                                                d="M571 393Q571 407 561 418L311 668Q300 679 286 679T261 668L11 418Q0 407 0 393T11 368 36 357H536Q550 357 561 368T571 393Z"
                                                                                                fill="black"
                                                                                                stroke="black"
                                                                                            />
                                                                                        </svg>
                                                                                        </div>
                                                                                        <div id="expiration-year" className="hosted-field-year elementor-field-textual elementor-size-sm" style={{ background: 'white', padding: '0px' }}></div>

                                                                                    </div>
                                                                                </div>
                                                                                <div
                                                                                    className="elementor-field-type-text elementor-field-group elementor-column elementor-field-group-field_463ef3d elementor-col-33 mobile-card-details">
                                                                                    <label htmlFor="form-field-field_463ef3d"
                                                                                        className="elementor-field-label elementor-screen-only">
                                                                                        CVV </label> <div id="cvv"

                                                                                            className="hosted-field hosted-field-cvv elementor-field elementor-size-sm  elementor-field-textual"
                                                                                            placeholder="CVV" /> </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                {tokenErrorCard ?
                                                                    <div className="errorCardMessage">
                                                                        Invalid Card Number. Please correct.
                                                                    </div>
                                                                    : null}


                                                                {tokenErrorCvv ?
                                                                    <div className="errorCvvMessage">
                                                                        Invalid CVV Number. Please correct.
                                                                    </div>
                                                                    : null}

                                                                {tokenErrorExptMonthYear ?
                                                                    <div className="errorMonthMessage">
                                                                        Invalid Expiration Date. Please correct.
                                                                    </div>
                                                                    : null}

                                                                {errorMessageProcess ?
                                                                    <div className="errorProcessOrdrBraintree">
                                                                        {errorMessageProcess}
                                                                    </div>
                                                                    : null}

                                                                {postalCodeError ?
                                                                    <div className="errorPostalCodeBraintree">
                                                                        Invalid Billing Information, please correct the fields in red.
                                                                    </div>
                                                                    : null}

                                                                {formValidationState ?
                                                                    <div className="errorOrderForm" style={{ color: 'red', padding: '0px 101px 0px 0px', fontSize: '16px' }}>
                                                                        Please fill all the fields
                                                                    </div>
                                                                    : null}



                                                                <div className="elementor-element elementor-element-abed916 elementor-widget elementor-widget-html"
                                                                    data-id="abed916" data-element_type="widget"
                                                                    data-widget_type="html.default">
                                                                    <div className="elementor-widget-container">
                                                                        <div className="order-info" style={{ marginTop: tokenErrorCvv || tokenErrorExptMonthYear || errorMessageProcess || postalCodeError || formValidationState ? '6px' : '0px', height: '40px' }}>
                                                                            <div className="PayPal-btn"><div id="paypal-button"></div>
                                                                            </div>
                                                                            <div className="place-order-btn" style={{ height: '37px' }}>
                                                                                <input type="submit" id="submitBtn" value="Place Order" disabled={loading} style={{ padding: !this.isMobile() ? '0px' : '0px', width: '-webkit-fill-available', height: !this.isMobile() ? '37px' : '40px' }}></input></div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </section>
                                            </form>
                                        </div>
                                    </div>
                                    <div className="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-37ff4bf elementor-hidden-tablet elementor-hidden-mobile"
                                        data-id="37ff4bf" data-element_type="column"
                                        data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
                                        <div className="elementor-widget-wrap"> </div>
                                    </div>
                                </div>
                            </section>
                            <section
                                className="elementor-section elementor-top-section elementor-element elementor-element-3403ade elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                                data-id="3403ade" data-element_type="section" style={{ marginTop: '13px' }}>
                                <div className="elementor-container elementor-column-gap-default">
                                    <div className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-d464db2"
                                        data-id="d464db2" data-element_type="column">
                                        <div className="elementor-widget-wrap elementor-element-populated">
                                            <div className="elementor-element elementor-element-fb8bde3 elementor-widget elementor-widget-text-editor"
                                                data-id="fb8bde3" data-element_type="widget" data-widget_type="text-editor.default">
                                                <div className="elementor-widget-container"> IF YOU HAVE ANY QUESTIONS CONTACT US AT:
                                                    1-866-848-8484 OR EMAIL <a className="in-text-link"
                                                        href="mailto:support@masterwriter.com">SUPPORT@MASTERWRITER.COM</a> </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                            <section
                                className="elementor-section elementor-top-section elementor-element elementor-element-e2d78d3 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                                data-id="e2d78d3" data-element_type="section">
                                <div className="elementor-container elementor-column-gap-default">
                                    <div className="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-042348c elementor-hidden-mobile"
                                        data-id="042348c" data-element_type="column">
                                        <div className="elementor-widget-wrap"> </div>
                                    </div>
                                    <div className="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-8d05e4d"
                                        data-id="8d05e4d" data-element_type="column">
                                        <div className="elementor-widget-wrap elementor-element-populated">
                                            <section
                                                className="elementor-section elementor-inner-section elementor-element elementor-element-0689cb1 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                                                data-id="0689cb1" data-element_type="section">
                                                <div className="elementor-container elementor-column-gap-default">
                                                    <div className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-28f1a14"
                                                        data-id="28f1a14" data-element_type="column">
                                                        <div className="elementor-widget-wrap elementor-element-populated">
                                                            <div className="elementor-element elementor-element-0452ba5 elementor-widget elementor-widget-image"
                                                                data-id="0452ba5" data-element_type="widget"
                                                                data-widget_type="image.default">
                                                                <div className="elementor-widget-container"> <LazyLoad width="291" height="291"><img decoding="async"
                                                                    src={`${process.env.PUBLIC_URL || ''}/images/2022-10-guarantee_badge.png`}
                                                                    className="attachment-large size-large wp-image-9996" alt=""
                                                                    loading="lazy"
                                                                    srcSet={`${process.env.PUBLIC_URL || ''}/images/2022-10-guarantee_badge.png 291w, ${process.env.PUBLIC_URL || ''}/images/2022-10-guarantee_badge-150x150.png 150w`}
                                                                    sizes="(max-width: 291px) 100vw, 291px" /></LazyLoad> </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-566bc6f"
                                                        data-id="566bc6f" data-element_type="column">
                                                        <div className="elementor-widget-wrap elementor-element-populated">
                                                            <div className="elementor-element elementor-element-b1b24bc elementor-widget elementor-widget-text-editor"
                                                                data-id="b1b24bc" data-element_type="widget"
                                                                data-widget_type="text-editor.default">
                                                                {licenseTypePage === 'CW' || licenseTypeDisRecurringPage === 'CW' || licenseTypeOneYearRecurringPage === 'CW' || licenseTypeTrialDiscount === 'CW' ?
                                                                    <div className="elementor-widget-container">If you aren&apos;t 100% 
                                                                    satisfied with your purchase of MasterWriter, let us know within 
                                                                    90 days and we&apos;ll give you your money back. Our mission is to 
                                                                    make you a better writer. We&apos;re confident MasterWriter will 
                                                                    help. But if it doesn&apos;t, then you shouldn&apos;t be charged for it. 
                                                                    Simple as that!
                                                                    </div> : null}
                                                                {licenseTypePage === 'SW' || licenseTypeDisRecurringPage === 'SW' || licenseTypeOneYearRecurringPage === 'SW' || licenseTypeTrialDiscount === 'SW' ?
                                                                    <div className="elementor-widget-container"> If you aren&apos;t 100%
                                                                        satisfied with your purchase of MasterWriter, let us know within
                                                                        90 days and we&apos;ll give you your money back. Our mission is to
                                                                        make you a better songwriter. We&apos;re confident MasterWriter will
                                                                        help. But if it doesn&apos;t, then you shouldn&apos;t be charged for it.
                                                                        Simple as that!
                                                                    </div> : null}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </section>
                                        </div>
                                    </div>
                                    <div className="elementor-column elementor-col-33 elementor-top-column elementor-element elementor-element-8c0d5ed elementor-hidden-mobile"
                                        data-id="8c0d5ed" data-element_type="column">
                                        <div className="elementor-widget-wrap"> </div>
                                    </div>
                                </div>
                            </section>
                            <section
                                className="elementor-section elementor-top-section elementor-element elementor-element-24c9636 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                                data-id="24c9636" data-element_type="section">
                                <div className="elementor-container elementor-column-gap-default">
                                    <div className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-670e7fe"
                                        data-id="670e7fe" data-element_type="column">
                                        <div className="elementor-widget-wrap elementor-element-populated">
                                            <div className="elementor-element elementor-element-97594b1 elementor-widget elementor-widget-spacer"
                                                data-id="97594b1" data-element_type="widget" data-widget_type="spacer.default">
                                                <div className="elementor-widget-container">
                                                    <div className="elementor-spacer">
                                                        <div className="elementor-spacer-inner"></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>
                        <div className="post-tags"> </div>
                    </div>
                </main>
                <Footer
                    data="Order-page" />
            </>
        )
    }
}


export default WithRouter(Order);
